import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import LoginPage from "@/views/pages/login.vue";
import Layout from "@/views/layouts/common/qMaster.vue";
import MenuListPage from "@/views/pages/menu/menuList.vue";
import RecommendationsPage from "@/views/pages/recommendation/index.vue";
import OrderHistoriesPage from "@/views/pages/history/index.vue";
import CheckPage from "@/views/pages/checking/index.vue";

Vue.use(VueRouter);

const baseRouter: Array<RouteConfig> = [
  {
    path: "/login",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      pageTitle: "ADMIN SCREEN // MuuQ-BASE",
    },
    component: LoginPage,
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/pages/logout.vue"),
  },
  {
    path: "*",
    name: "error",
    component: () => import("../views/pages/error.vue"),
  },
  {
    path: "/",
    name: "",
    component: Layout,
    meta: {
      allowRole: [],
    },
    children: [
      {
        path: "menu",
        name: "menu",
        component: MenuListPage,
        meta: {
          pageTitle: "メニュー卓",
          title: "メニュー卓",
          subTitle: "メニュー卓",
          className: "",
        },
      },
      {
        path: "recommendations",
        name: "recommendations",
        component: RecommendationsPage,
        meta: {
          pageTitle: "おすすめ卓",
          title: "おすすめ卓",
          subTitle: "おすすめ卓",
          className: "",
        },
      },
      {
        path: "order-histories",
        name: "histories",
        component: OrderHistoriesPage,
        meta: {
          pageTitle: "注文履歴卓",
          title: "注文履歴卓",
          subTitle: "注文履歴卓",
          className: "",
        },
      },
      {
        path: "check",
        name: "check",
        component: CheckPage,
        meta: {
          pageTitle: "お会計卓",
          title: "お会計卓",
          subTitle: "お会計卓",
          className: "",
        },
      },
    ]
  },
];

const routes = [...baseRouter];

const router = new VueRouter({
  mode: "history",
  // base: process.env.NODE_ENV === "development" ? process.env.BASE_URL : "",
  routes,
});

// todo will open when check login
// router.beforeEach(async (to, from, next) => {
//   if (to.name != "login" && !store.state.Auth.token) {
//     next({
//       name: "login",
//     });
//   } else {
//     if (to.name === "login" && store.state.Auth.token) {
//       next({
//         name: "my-page",
//       });
//     } else if (
//       to.matched[0] &&
//       to.matched[0].meta.allowRole &&
//       to.matched[0].meta.allowRole.includes(store.state.Auth.role)
//     ) {
//       next();
//     } else {
//       // TODO: redirect to 403 page
//       next();
//     }
//   }
// });

router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.pageTitle || "";
  });
});
export default router;
